export const environment = {
    production: false,
    title: 'Staging Environment',
    apiVersion: 'v1',
    apiURL: 'https://dev-wellsite.aemenersol.com/api',
    mfeReactUrl: 'https://dev-wellsite.aemenersol.com:76/remoteEntry.js'
};
